import React, { FC } from "react";
import classes from "./SelectProductItemsMain.module.scss";
import { backColorModal } from "../../../../commons/colors";
import ProductionDepartment from "./department/ProductionDepartment";
import {
  productDepartments,
  productItems,
} from "../../../../commons/productItems";
import { User } from "../../../types/user";
import { Box } from "@mui/material";
type Props = {
  checkedItems: Number[];
  setCheckedItems: React.Dispatch<React.SetStateAction<Number[]>>;
};
const SelectProductItemsMain: FC<Props> = (props) => {
  const { checkedItems, setCheckedItems } = props;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
      {productDepartments.map((department) => {
        const filteredProductItemns = productItems.filter(
          (item) => item.department === department.name
        );
        return (
          <ProductionDepartment
            key={department.id}
            departmentId={department.id}
            departmentName={department.name}
            productItems={filteredProductItemns}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
          />
        );
      })}
    </Box>
  );
};

export default SelectProductItemsMain;
